import { render, staticRenderFns } from "./approve_asset.vue?vue&type=template&id=20c6caa8&scoped=true"
import script from "./approve_asset.vue?vue&type=script&lang=js"
export * from "./approve_asset.vue?vue&type=script&lang=js"
import style0 from "./approve_asset.vue?vue&type=style&index=0&id=20c6caa8&prod&lang=css&scoped=true"
import style1 from "./approve_asset.vue?vue&type=style&index=1&id=20c6caa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6caa8",
  null
  
)

export default component.exports